import React from "react";
import CivicPointsIconLogo from "../../../../assets/icons/civicpoints_logo.svg";
import { HeroSection } from "../../components/HeroSection";
import { MerchantRegisterStepper } from "../components/MerchantRegisterStepper";
import { MerchantStep } from "../types/merchantRegister.types";
import { useLocalization } from "../../../../hooks/useLocalization";

export const MerchantRegisterPage: React.FC<{ currentStep: number; page: React.ReactNode }> = ({
  currentStep,
  page,
}) => {
  const { t } = useLocalization();
  const steps: MerchantStep[] = [
    {
      id: "account",
      title: t("merchantRegister.step1.title"),
    },
    {
      id: "verify",
      title: t("merchantRegister.step2.title"),
      // previousBtn: { label: t("merchantRegister.buttons.back"), onClick: handleBack },
      // nextBtn: {
      //   label: t("merchantRegister.buttons.verifyAccount"),
      //   onClick: handleVerify,
      //   loading: isSubmitting,
      // },
    },
    {
      id: "success",
      title: t("merchantRegister.step3.title"),
      // previousBtn: { label: t("merchantRegister.buttons.back"), onClick: handleBack },
      // nextBtn: { label: t("merchantRegister.buttons.continue"), onClick: () => goToStep(3) },
    },
    {
      id: "business",
      title: t("merchantRegister.step4.title"),
      // previousBtn: { label: t("merchantRegister.buttons.back"), onClick: handleBack },
      // nextBtn: {
      //   label: t("merchantRegister.buttons.next"),
      //   onClick: handleBusiness,
      //   loading: isSubmitting,
      // },
    },
  ];

  return (
    <div className="flex flex-col lg:flex-row min-h-screen bg-white dark:bg-gray-900">
      <div className="lg:hidden flex items-center justify-center py-8 bg-[#eef9ef] dark:bg-[#0d2818]">
        <img
          src={CivicPointsIconLogo}
          alt="CivicPoints"
          className="h-12 w-auto dark:opacity-90"
        />
      </div>
      <HeroSection />
      <div className="flex-1 lg:w-[50%] flex flex-col bg-white dark:bg-gray-900">
        <div className="flex-1 flex flex-col px-6 py-8 sm:px-10 sm:py-10 lg:px-[60px] lg:py-[50px]">
          <div className="w-full flex-1 flex flex-col gap-[30px] overflow-auto max-h-[calc(100vh-60px)]">
            <MerchantRegisterStepper
              steps={steps}
              currentStep={currentStep}
            />
            {page}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MerchantRegisterPage;
